import React from "react"
import MapGL, { Marker, Popup, NavigationControl } from "react-map-gl"
import { faMapPin } from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { logoForShop } from "../../../shared_component/utils/shopLogos"
import isEqual from "lodash/isEqual"
import SavingsRibbon from "./SavingsRibbon"
import Button from "../Button"
import { withTranslation } from "react-i18next"
import { getPricingInfo } from "../../helpers/shopHelpers"
import { getNewTiresServiceFromServices } from "../../helpers/orderServiceHelpers"
import { MD_HD_VEHICLE_TYPE_ID } from "../../constants/application"

const ICON_WIDTH = 18
const ICON_HEIGHT = 32
const DEFAULT_ZOOM = 9

const navStyle = {
  position: "absolute",
  top: 10,
  left: 0,
  padding: "10px"
}

class ShopMap extends React.Component {
  constructor(props) {
    super(props)

    const firstShop = (props.shops && props.shops[0]) || {}
    const height = Math.max(window.innerHeight * 0.5, 300)
    this.state = {
      viewport: {
        width: "100%",
        height: `${height}px`,
        latitude: firstShop.latitude || 41.8786772,
        longitude: firstShop.longitude || -87.6451561,
        zoom: DEFAULT_ZOOM,
        minZoom: 2
      }
    }
  }

  updateViewport = (viewport) => {
    this.setState({ viewport })
  }

  componentDidUpdate(prevProps, prevState) {
    const { shops } = this.props
    const firstShop = shops && shops[0]
    if (!isEqual(prevProps.shops.map((s) => s.id).sort(), shops.map((s) => s.id).sort())) {
      let { viewport } = this.state
      viewport["zoom"] = DEFAULT_ZOOM
      viewport["latitude"] = firstShop.latitude
      viewport["longitude"] = firstShop.longitude
      this.setState({ viewport })
    }
  }

  render() {
    const {
      shops,
      onClickMarker,
      shouldDisplayPrice,
      orderServices,
      t,
      onSelect,
      vehicleTypeId
    } = this.props
    const selectedShop = this.props.selectedShop || {}
    const viewport = this.state.viewport

    return (
      <MapGL
        {...viewport}
        mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
        onViewportChange={this.updateViewport}
      >
        {shops.map((shop, index) => {
          const isSelectedShop = selectedShop && shop.id === selectedShop.id
          const { latitude, longitude } = shop
          const src = logoForShop(shop)
          let logo =
            src !== undefined ? <img style={{ width: "50px", margin: "0 auto" }} src={src} /> : null
          const pricingInfo = getPricingInfo(
            !!getNewTiresServiceFromServices(orderServices),
            shop.supports_tire_selection,
            shop.shopPriceText,
            shop.shopPriceEstimate,
            shop,
            t,
            vehicleTypeId
          )
          return (
            <React.Fragment>
              <Marker
                key={`marker-${index}`}
                latitude={latitude}
                longitude={longitude}
                offsetLeft={-(ICON_WIDTH / 2)}
                offsetTop={-ICON_HEIGHT}
                className={`${isSelectedShop ? "onTop" : ""}`}
              >
                <FontAwesomeIcon
                  icon={faMapPin}
                  fixedWidth
                  className={isSelectedShop ? "caradvise-electric-blue" : "caradvise-orange"}
                  style={{
                    cursor: "pointer",
                    width: `${ICON_WIDTH}px`,
                    height: `${ICON_HEIGHT}px`
                  }}
                  onClick={() => onClickMarker(shop)}
                />
              </Marker>
              {isSelectedShop && (
                <Popup
                  className="onTop"
                  latitude={latitude}
                  longitude={longitude}
                  closeOnClick={false}
                  closeButton={true}
                  onClose={() => onClickMarker(shop)}
                  anchor="bottom"
                  offsetTop={-ICON_HEIGHT}
                  style={{ padding: "5px", zIndex: 9999 }}
                >
                  <div>{logo}</div>
                  {shouldDisplayPrice && <div className="shopPopupText">{pricingInfo}</div>}
                  {shop.hasRetailSavings &&
                    !shop.cdk_dealer &&
                    vehicleTypeId !== MD_HD_VEHICLE_TYPE_ID && (
                      <SavingsRibbon
                        savingsText={shop.total_retail_savings}
                        containerStyle={{ margin: "5px 5px 0 5px" }}
                        ribbonStyle={{ width: "100%" }}
                        textStyle={{ minWidth: "125px" }}
                      />
                    )}
                  <Button
                    key={`btn-select-shop-tooltip-${selectedShop.id}`}
                    text={t("selectText")}
                    colorStyle="orange"
                    onClick={() => onSelect(selectedShop, pricingInfo)}
                    style={{ height: "10px", minWidth: "90px", margin: "8px" }}
                  />
                </Popup>
              )}
            </React.Fragment>
          )
        })}

        <div className="nav" style={navStyle}>
          <NavigationControl onViewportChange={this.updateViewport} />
        </div>
      </MapGL>
    )
  }
}

export default withTranslation("common")(ShopMap)
